<div class="layout-wrapper" [ngClass]="containerClass">
  <app-topbar></app-topbar>

  <div class="layout-sidebar" [ngClass]="layoutService.state.staticMenuDesktopInactive ? 'min-sidebar' : ''">
    <div (click)="layoutService.onMenuToggle()"
         class="p-1 border-1 border-200 border-round-xs surface-50 cursor-pointer collapse-btn"
         [pTooltip]="layoutService.state.staticMenuDesktopInactive ? 'Ausklappen' : 'Einklappen'"
         [ngClass]="layoutService.state.staticMenuDesktopInactive ? 'side-collapse' : 'side-expand'">
      <i class="text-sm"
         [ngClass]="layoutService.state.staticMenuDesktopInactive ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"></i>
    </div>
    <app-sidebar></app-sidebar>
  </div>
  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <!--
      <app-footer></app-footer>
      -->
  </div>
  <!-- <app-config></app-config>-->
  <div class="layout-mask"></div>
</div>
